import classNames from "classnames";
import { Result } from "~/models/search-result";
import { SearchAutocompleteTag } from "./SearchAutocompleteTag";

export interface SearchAutocompleteSectionProps {
  searchTerm: string;
  title?: string;
  results?: Result[];
}

// Custom limits based on section
const resultsLimit = (title: string) => {
  switch (title.toLowerCase()) {
    case "where to give now": {
      return 3;
    }
    case "organizations": {
      return 10;
    }
    case "causes": {
      return 5;
    }
    default: {
      return 20;
    }
  }
};

export function SearchAutocompleteSection(
  props: SearchAutocompleteSectionProps,
) {
  return (
    <div
      className={classNames("autocomplete-section", "tw:mb-4")}
      data-testid="searchAutocompleteSection"
    >
      <h2
        className="tw:!text-night-sky-800 tw:!mb-2 tw:!text-base"
        data-testid="searchResultTitle"
      >
        {props.title}
      </h2>
      <div className="flow-root">
        <div
          className={classNames(
            "autocomplete-section",
            "tw:-m-1 tw:flex tw:flex-wrap",
          )}
          data-testid="searchTag"
        >
          {(props.results == null || props.results.length === 0) && (
            <p className="tw:!pl-3">No results found</p>
          )}
          {props.results &&
            props.results!.length > 0 &&
            props.results
              ?.slice(0, resultsLimit(props.title || ""))
              .map((results) => (
                <SearchAutocompleteTag
                  key={results.url}
                  section={props.title || ""}
                  searchTerm={props.searchTerm}
                  ein={results.ein}
                  name={results.title}
                  url={results.url}
                />
              ))}
        </div>
      </div>
    </div>
  );
}
